export const name = "CHARACTER_LENGTH";
export const summary = `Synonym for \`CHAR_LENGTH\`.`;
export const reference = `
## CHARACTER_LENGTH

Synonym for \`CHAR_LENGTH\`.

\`\`\`
CHARACTER_LENGTH(value)
\`\`\`

### Description

Synonym for CHAR_LENGTH.


### Return type

\`INT64\`


### Examples



\`\`\`
SELECT
  'абвгд' AS characters,
  CHARACTER_LENGTH('абвгд') AS char_length_example

/*------------+---------------------*
 | characters | char_length_example |
 +------------+---------------------+
 | абвгд | 5 |
 *------------+---------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
